import React, { useEffect, useContext } from "react";
import MapContext from "../Map/MapContext";
import { setRunningUrlQuery } from "../redux/setConfigSlice";
import { setResultsData } from "../redux/resultsSlice";
import { getMapLayerById } from "../Map/utils/mapUtils";
import { useDispatch, useSelector } from "react-redux";

const UrlQuery = () => {
    const dispatch = useDispatch();
    const { map } = useContext(MapContext);
    const urlQuery = useSelector((state) => state.configData.urlQuery);
    const siteLoading = useSelector((state) => state.configData.siteLoading);
    const layerProperties = useSelector(
        (state) => state.configData.vectorLayerProperties
    );

    useEffect(() => {
        if (!map) return;
        if (siteLoading) return;
        if (urlQuery === false) return;
        // Get layer data from redux
        const layer = layerProperties.find(
            (l) => l.DisplayName.toLowerCase() === urlQuery.layer.toLowerCase()
        );
        // Get layer from map
        const mapLayer = getMapLayerById(map, layer?.Id);
        // Get all features in layer
        const features = mapLayer?.getSource()?.getFeatures();
        // Find features with query fields matching the query value
        const result =
            features?.filter((f) => {
                const fieldsObj = f?.values_;
                // Find key in non case sensitive way
                const fieldKey = Object.keys(fieldsObj).find(
                    (key) => key.toString().toLowerCase() === urlQuery.field.toLowerCase()
                );
                return (
                    fieldsObj[fieldKey]?.toString()?.toLowerCase() ===
                    urlQuery.value.toString().toLowerCase()
                );
            }) ?? [];
        if (result.length > 0) {
            const results = {
                DisplayName: layer.DisplayName,
                FeatureLabel: layer.FeatureLabel,
                FeatureDescription: layer.FeatureDescription,
                Id: layer.Id,
                Features: result.map((r) => r?.id_),
            };
            dispatch(setResultsData([results]));
        }
        dispatch(setRunningUrlQuery(false));
    }, [map, urlQuery, siteLoading]);
    return <></>;
};

export default UrlQuery;
